import React from 'react';

import { Icon, Button, Accordion } from 'semantic-ui-react';
import ReactS3Uploader from 'react-s3-uploader';
import VideoRecorder from '../VideoRecorder';
import config from '../../config';
import { getContrast } from '../../helpers/commonHelper';
import { ACCEPT_TYPES } from '../../constants'

import { COLORS } from '../../constants';

import isMobile from 'is-mobile';

import './style.css';

const extractPathData = data => {
  if (!data || !data.url) return null;

  return data.url.split('?')[0];
}

export const UploadVideoAccordion = ({
  activeIndex,
  question,
  campaignColor,
  handleDeleteVideo,
  handleRetakeVideo,
  handleStartRecording,
  handleUploadVideo,
  handleUploadRecordVideo,
  handleUploadFinish,
  handleRecordVideo,
  handleUploadVideoError,
  handleUploadStart,
  handleUploadProgress,
  handleOnCancelRecord,
  uploadError,
  handleAccordion,
  videoDurationError,
  videosUploaded,
  uploader,
  uploadInput,
  startRecording,
  reRender,
  videoDuration,
  questionKey,
  videoPlayer,
  recordVideosUploaded,
  isRecordingSupported,
  onRecordedVideoUploadStart,
  onRecordedVideoUploadEnd,
}) => {
  const active = activeIndex === questionKey;

  const contrastColor =
    getContrast(campaignColor) === COLORS.white
      ? 'white'
      : 'black';

  const styleButton = {
    background: campaignColor,
    color: contrastColor,
  };

  const uploadedFileData = videosUploaded[question.id];
  const recordedVideoData = recordVideosUploaded[question.id];

  return (
    <Accordion
      className='accordion'
      style={campaignColor && { borderLeft: `solid 2px ${campaignColor}` }}
    >
      <Accordion.Title
        index={questionKey}
        active={active}
        onClick={handleAccordion}
        className='accordion-title'
      >
        <Icon name='play circle outline' size='big' />
        <h1 className="vp-question-title"> {question.question}</h1>
        <Icon name={active ? 'angle up' : 'angle down'} color='grey' />
      </Accordion.Title>

      <Accordion.Content active={active} className='accordion-content'>
        <p>{question.description}</p>
        <div className='accordion-upload-video'>
          {(!uploadedFileData && !recordedVideoData) && !startRecording[activeIndex] && (
            <UploadVideoContainer
              handleStartRecording={handleStartRecording}
              handleUploadVideo={handleUploadVideo}
              questionKey={questionKey}
              contrastColor={contrastColor}
              styleButton={styleButton}
              isRecordingSupported={isRecordingSupported}
            />
          )}
          {(uploadedFileData || recordedVideoData) && (
            <UploadedVideoContainer
              handleDeleteVideo={handleDeleteVideo}
              handleRetakeVideo={handleRetakeVideo}
              videoPlayer={videoPlayer}
              uploadedFileData={uploadedFileData}
              recordedVideoData={recordedVideoData}
              question={question}
              questionKey={questionKey}
              contrastColor={contrastColor}
              styleButton={styleButton}
            />
          )}
        </div>

        {startRecording[activeIndex] && reRender && (
          <VideoRecorder
            uniqueWebKey={questionKey}
            videoId={question.id}
            onUploadRecordVideo={handleUploadRecordVideo}
            onUploadFinish={handleUploadFinish}
            onRecordVideo={handleRecordVideo}
            onUploadVideoError={handleUploadVideoError}
            contrastColor={contrastColor}
            styleButton={styleButton}
            onCancelRecord={handleOnCancelRecord}
            onRecordedVideoUploadStart={onRecordedVideoUploadStart}
            onRecordedVideoUploadEnd={onRecordedVideoUploadEnd}
          />
        )}

        {videoDurationError[question.id] && (
          <p className='accordion-error'>
            Sorry, your video duration is more than 5 minutes!
          </p>
        )}

        <S3Uploader
          handleUploadStart={handleUploadStart}
          handleUploadProgress={handleUploadProgress}
          handleUploadFinish={handleUploadFinish}
          question={question}
          questionKey={questionKey}
          videoDuration={videoDuration}
          uploader={uploader}
          uploadError={uploadError}
          uploadInput={uploadInput}
        />
      </Accordion.Content>
    </Accordion>
  );
};

const UploadVideoContainer = ({
  handleStartRecording,
  handleUploadVideo,
  contrastColor,
  questionKey,
  styleButton,
  isRecordingSupported
}) => (
  <div className='accordion-buttons-container'>
    {isMobile({ tablet: true }) ? (
      <Button
        className='uploadbtn'
        icon={<Icon name='video camera' color={contrastColor} />}
        content='Upload or Record Video'
        buttonKey={questionKey}
        onClick={handleUploadVideo}
        style={styleButton}
      />
    ) : (
      <React.Fragment>
        {isRecordingSupported &&
        <Button
          className='uploadbtn'
          icon={<Icon name='video camera' color={contrastColor} />}
          content='Record Video'
          buttonKey={questionKey}
          onClick={handleStartRecording}
          style={styleButton}
        />}
        <Button
          className='uploadbtn'
          icon={<Icon name='upload' color={contrastColor} />}
          content='Upload Video'
          buttonKey={questionKey}
          onClick={handleUploadVideo}
          style={styleButton}
        />
      </React.Fragment>
    )}
  </div>
);

const UploadedVideoContainer = ({
  handleDeleteVideo,
  handleRetakeVideo,
  videoPlayer,
  question,
  uploadedFileData,
  questionKey,
  contrastColor,
  styleButton,
  recordedVideoData
}) => (
  <div className='accordion-show-video-container'>
    <video
      id={`video-campaign-${question.id}`}
      ref={(refr) => (videoPlayer[question.id] = refr)}
      preload='metadata'
      width='85%'
      height='auto'
      controls
      playsInline={isMobile({ tablet: true }) ? 1 : 0}
      className='accordion-video'
    >
      {!!uploadedFileData ? (
        <source
          src={URL.createObjectURL(uploadedFileData)}
          type='video/mp4'
        />
      ) : (
        <source src={extractPathData(recordedVideoData)} type='video/mp4' />
      )}
    </video>
    <div className='accordion-buttons-container'>
      <Button
        onClick={() => handleRetakeVideo(question.id, questionKey)}
        className='uploadbtn'
        icon={<Icon name='upload' color={contrastColor} />}
        content='Retake Video'
        style={styleButton}
      />
      <Button
        onClick={() => handleDeleteVideo(question.id, questionKey)}
        className='uploadbtn delete-button'
        icon={<Icon name='delete' color='white' />}
        content='Delete Video'
      />
    </div>
  </div>
);

const S3Uploader = ({
  handleUploadStart,
  handleUploadProgress,
  handleUploadFinish,
  question,
  questionKey,
  videoDuration,
  uploader,
  uploadInput,
  uploadError,
}) => (
  <div className='s3-container'>
    <ReactS3Uploader
      signingUrl='/videos/s3/sign'
      signingUrlMethod='GET'
      accept={`${ACCEPT_TYPES.VIDEO}`}
      preprocess={(e, next) => handleUploadStart(e, next, question.id)}
      onProgress={(e) => handleUploadProgress(e, questionKey, question.id)}
      onError={() => uploadError(questionKey, question.id)}
      onFinish={(e) => handleUploadFinish(e, question.id)}
      signingUrlHeaders={{
        additional: { 'Access-Control-Allow-Origin': '*' },
      }}
      signingUrlQueryParams={{ duration: videoDuration[question.id] }}
      signingUrlWithCredentials={true} // in case when need to pass authentication credentials via CORS
      uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }} // this is the default
      server={config.apiHost}
      ref={(cmp1) => (uploader[questionKey] = cmp1)}
      inputRef={(cmp) => (uploadInput[questionKey] = cmp)}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Accordion/index.jsx